/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { categoryStore, categoryActions } from './store.js';
import { hashHistory, withRouter } from 'react-router';
import { Icon, Button, Menu, Dropdown, message } from 'antd';
import { DmsTab, TableView, FilterBox } from 'Components';
import { categoryList, categoryInvalid, productAync,categoryLevel } from '../../service/category';
import {openNotice} from 'Utils';

class CategoryList extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = Reflux.initStore(categoryStore); //创建一个Store实例
    this.state = {
      opts: ['产品分类'],
      key: 0,
      filterBoxVisible: false,
      rows: [],
      msg: 'hahahahha',
      total: 0,
      selectedKeys: [],
      searchObj: {
        name: '',
        level: '',
        active: null,
        p: 1,
        s: 10
      },
      option: []
    };

    this.pageChange = this.pageChange.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.dropdownClick = this.dropdownClick.bind(this);
    this.goView = this.goView.bind(this);
    this.getData = this.getData.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
    this.getLevel = this.getLevel.bind(this);
  }

  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    const { searchObj } = this.state;
    let path = nextLocation.pathname.split('/');
    let editindex = nextLocation.query.editindex;
    if (path[1] === 'category' && path[2] === 'categoryadd' && editindex) { //当下一个路由是详情页时，将useStore的值设为true
      categoryActions.useStoreChange(true);
      categoryActions.paramChange(searchObj);
    } else {
      categoryActions.useStoreChange(false);
      categoryActions.paramChange({});
    }
  }

  componentWillMount() {
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        searchObj: data.storeData
      });
    }
  }

  componentDidMount() {
    this.getData();
    this.getLevel();
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  componentWillUnmount() {
    this.setState = ()=> false;
  }

  //页面跳转
  goView(url) {
    hashHistory.push(url);
  }

  getLevel() {
    categoryLevel({}).then(res => {
      if (res.status) {
        var levelArr = [];
        if (res.data) {
          for (var m = 1; m < res.data + 1; m++) {
            var levelObj = {};
            levelObj.value = m.toString();
            levelObj.text = m.toString() + '级';
            levelArr.push(levelObj);
          }
        }
        var all = { value: '', text: '全部' };
        levelArr.push(all);
        this.setState({
          option: levelArr
        })
      } else {
        message.error(res.message);
      }
    })
  }

  getData() {
    var obj = this.state.searchObj;
    categoryList(obj).then(result => {
      if (result.status) {
        var rowsArr = result.data;
        var findArr = [];

        //遍历加字
        for (var l = 0; l < rowsArr.length; l++) {
          findArr.push(rowsArr[l].level);
          var level = rowsArr[l].level;
          rowsArr[l].level = level + '级';
        }
        this.setState({
          rows: rowsArr,
          total: result.total
        })

      } else {
        message.error(result.message);
      }
    })
  }

  visibleChange() {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset() {
    const self = this;
    this.setState({
      filterBoxVisible: !this.state.filterBoxVisible,
      searchObj: {
        ...this.state.searchObj,
        name: '',
        level: '',
        active: null,
        p: 1
      }
    }, () => {
      self.getData();
    });
  };

  //筛选
  advanceSubmit(form) {
    var submitObj = { ...this.state.searchObj };
    submitObj.p = 1;
    //有效性选择

    submitObj.active = submitObj.active || null;

    //级别选择
    submitObj.level = parseInt(submitObj.level, 0) || '';

    const self = this;
    this.setState({
      filterBoxVisible: !this.state.filterBoxVisible,
      searchObj: submitObj
    }, function () {
      self.getData();
    });
  };

  setFilterParam(name, value) {
    this.setState({ searchObj: { ...this.state.searchObj, [name]: value } });
  };

  pageChange(page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
      self.getData();
    });
  }

  onVisibleChange(visible) {
    this.setState({
      selectedKeys: []
    });
  }

  dropdownClick({ item, key, keyPath }) {
    const { selectedKeys } = this.state;
    selectedKeys.push(key);
    this.setState({
      selectedKeys
    });
    var arr = key.split('_');
    //编辑
    if (arr[0] === '0') {
      window.location.assign('#/category/categoryadd?addindex=' + this.state.rows[arr[1]].id);
    }

    //新增子类
    if (arr[0] === '1') {
      window.location.assign('#/category/categoryadd?editindex=' + this.state.rows[arr[1]].id);
    }
    //失效
    if (arr[0] === '2') {
      var failureObj = {};
      failureObj.id = this.state.rows[arr[1]].id;
      if (this.state.rows[arr[1]].active === 'Y') {
        failureObj.active = 'N';
      } else {
        failureObj.active = 'Y';
      }
      categoryInvalid(failureObj).then(result => {
        if (result.status) {
          message.success(result.message);
          this.getData();
        } else {
          message.error(result.message);
        }
      })

    }
    ;
    //删除
    /*if (arr[0] === '3') {
     var deleteObj={};
     deleteObj.id=this.state.rows[arr[1]].id;
     categoryDelete(deleteObj).then(result=>{
     if(result.status){
     message.success(result.message);
     this.getData(this.state.storeData);
     }else{
     message.error(result.message);
     }
     })
     };*/
  }

  menu(index) {
    return <Menu
      style={{ width: "100px", textAlign: 'center' }}
      onClick={this.dropdownClick}
      selectedKeys={this.state.selectedKeys}>
      <Menu.Item key={`0_${index}`}>
        增加子类
      </Menu.Item>
      <Menu.Item key={`1_${index}`}>
        编辑
      </Menu.Item>
      <Menu.Item key={`2_${index}`}>
        {
          this.state.rows[index].active === 'Y' ?
            '失效'
            :
            '有效'
        }
      </Menu.Item>
      {/*<Menu.Item key={`3_${index}`}>
       删除
       </Menu.Item>*/}
    </Menu>
  }
  sync() {
    productAync().then(res=>{
      if (res && res.code == 200) {
        openNotice('success', '同步成功,请等待5分钟', '');
      } else {
        openNotice('error', '同步失败', (res && res.message) ? res.message : '');
      }
    });
  }
  render() {
    const { opts, filterBoxVisible, rows, total, searchObj } = this.state;
    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'name',
            defaultValue: searchObj.name,
            label: '分类名称',
            text: '请输入分类名称',
            type: 'default'
          },
          {
            name: 'level',
            defaultValue: (searchObj.level) ? searchObj.level.toString() : '',
            label: '分类级别',
            options: this.state.option,
            type: 'select'
          },
          {
            name: 'active',
            defaultValue: (searchObj.active != null) ? searchObj.active.toString() : '',
            label: '有效性',
            options: [
              { value: '', text: '全部' },
              { value: 'Y', text: '有效' },
              { value: 'N', text: '无效' }
            ],
            type: 'select'
          }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: this.state.searchObj.p,//当前页码
        pageSize: this.state.searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [{
        title: '分类名称',
        dataIndex: 'name',
        render: text => <span>{text}</span>,
      }, {
        title: '分类路径',
        dataIndex: 'fullPath',
      }, {
        title: '分类级别',
        dataIndex: 'level',
      }, {
        title: '有效性',
        dataIndex: 'active',
        render: text => text === 'Y' ? <span style={{ color: 'green' }}>有效</span> :
          <span style={{ color: '#d61518' }}>无效</span>
      },
       {
       title: '更多操作',
       key: 'action',
       className: 'alignCenter',
       render: (text, record, index) => (
       <Dropdown
       overlay={this.menu(index)}
       placement='bottomCenter'
       trigger={['click']}
       onVisibleChange={this.onVisibleChange.bind(this)}>
       <span className="ant-dropdown-link">
       <Icon type="caret-down"/>
       </span>
       </Dropdown>
       )
       }],
      rows
    };
    return (
      <div className='dms-body'>
        <div>
          <DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
            <Button icon="plus"
                    onClick={this.goView.bind(this, '/category/categoryadd')}>新增</Button>
            <Button icon="reload" onClick={this.sync.bind(this)}>同步</Button>
            <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
            <FilterBox  {...filterBoxProps} />
          </DmsTab>
        </div>

        <div className="dms-table-box">
          <TableView {...tableViewProps} />
        </div>
      </div>
    )
  }
}
;
export default withRouter(CategoryList);



// WEBPACK FOOTER //
// ./src/routes/category/list.js